import useDidMountEffect from "hooks/useDidMountEffect";
import { useEffect } from "react";

// Two small, unrelated syncs bundled together purely because both just mirror
// row state into the surrounding context/DOM with no return value of their own.
const useTaskRowContextSync = ({ row, toggle, CtxDispatch }) => {
	useEffect(() => {
		CtxDispatch({ type: "SET_TOOLS", payload: row.hasTools });
		CtxDispatch({ type: "SET_PERMITS", payload: row.hasPermits });
		CtxDispatch({ type: "SET_IMAGES", payload: row.hasTaskImages });
		CtxDispatch({ type: "SET_QUESTIONS", payload: row.hasQuestions });
		CtxDispatch({ type: "SET_SAFETY", payload: row.safetyCritical });
		CtxDispatch({ type: "SET_DOCUMENTS", payload: row.hasDocuments });
		CtxDispatch({ type: "SET_PARTS", payload: row.hasParts });
	}, [CtxDispatch, row]);

	// The status icons in the "logo" cell invert to white when the row is
	// expanded (dark background) - toggled directly on the DOM rather than
	// through React state, since it only affects already-rendered icon nodes.
	useDidMountEffect(() => {
		const icons = document.querySelectorAll(`#taskExpandable${row.id}  > td > div > span > img`);
		icons?.forEach((icon) => icon.classList.toggle("white-filter", toggle));
	}, [toggle]);
};

export default useTaskRowContextSync;
